var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.disponivel)?_c('v-btn',{staticClass:"grey--text text--darken-4",attrs:{"depressed":"","color":"#25D366"},on:{"click":_vm.abrirWhatsApp}},[_vm._v("Avisar no WhatsApp")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }